// pdf-lib's built-in fonts can only encode WinAnsi (Windows-1252): Latin-1 plus a handful of
// typographic extras. Anything else (emoji, CJK, symbols) makes pdf-lib throw mid-render.
const WIN_ANSI_EXTRAS: ReadonlySet<string> = new Set([
  '€',
  '‚',
  'ƒ',
  '„',
  '…',
  '†',
  '‡',
  'ˆ',
  '‰',
  'Š',
  '‹',
  'Œ',
  'Ž',
  '‘',
  '’',
  '“',
  '”',
  '•',
  '–',
  '—',
  '˜',
  '™',
  'š',
  '›',
  'œ',
  'ž',
  'Ÿ',
]);

export const UNENCODABLE_REPLACEMENT = '?';

const LATIN_1_MAX = 0xff;
const CONTROL_MAX = 0x1f;
const C1_CONTROL_MIN = 0x7f;
const C1_CONTROL_MAX = 0x9f;
const TAB = 0x09;
const LINE_FEED = 0x0a;
const CARRIAGE_RETURN = 0x0d;

export function toWinAnsiText(text: string | null | undefined): string {
  if (!text) {
    return '';
  }

  // Array.from splits by code point, so a surrogate pair (emoji) becomes one replacement.
  return Array.from(text.normalize('NFC'))
    .map((char) => {
      const code = char.codePointAt(0) ?? 0;

      if (code === TAB || code === LINE_FEED || code === CARRIAGE_RETURN) {
        return ' ';
      }
      if (code <= CONTROL_MAX || (code >= C1_CONTROL_MIN && code <= C1_CONTROL_MAX)) {
        return '';
      }
      if (code <= LATIN_1_MAX || WIN_ANSI_EXTRAS.has(char)) {
        return char;
      }
      return UNENCODABLE_REPLACEMENT;
    })
    .join('');
}
